import { styled } from "@mui/material";
import { useLocation } from "react-router-dom";
import { buildTaxTransactionsArg } from "src/components/tax-center/utils";
import RouteItem, { SubRouteItem } from "src/model/RouteItem.model";
import api from "src/store/features/api";
import useDeviceSizes from "../portfolio/hooks/useDeviceSizes";

const TAX_TRANSACTION_REVIEW_PATH = "/tax-center/transactions";
const CURRENT_TAX_YEAR = new Date().getUTCFullYear();

const MenuItemWrapper = styled("div")({
  display: "flex",
  gap: "12px",
  alignItems: "center",
  fontSize: "16px",
  width: "100%",
});

const IconButton = styled("button")({
  display: "flex",
  alignItems: "center",
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  cursor: "pointer",
  font: "inherit",
  color: "inherit",
  outline: "none",
});

const TextContentWrapper = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
});

const MenuText = styled("span")<{ isActive?: boolean; expanded?: boolean }>(
  ({ isActive, expanded }) => ({
    fontWeight: isActive || expanded ? 600 : 400,
  }),
);

const NewLabel = styled("span")({
  color: "#fc4c4c",
  fontSize: "10px",
  fontWeight: 600,
});

const CountBadge = styled("span")({
  minWidth: "20px",
  height: "20px",
  padding: "0 6px",
  borderRadius: "999px",
  backgroundColor: "#fc4c4c",
  color: "#FFF",
  fontSize: "11px",
  fontWeight: 700,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
});

interface MenuItemContentProps {
  route: RouteItem | SubRouteItem;
  expanded?: boolean;
}

const MenuItemContent = ({ route, expanded }: MenuItemContentProps) => {
  const location = useLocation();
  const isActive = route.path === location.pathname;
  const { isMobile } = useDeviceSizes();

  const isTaxTransactionReview = route.path === TAX_TRANSACTION_REVIEW_PATH;
  const transactionsQuery = api.useGetTaxTransactionsQuery(
    buildTaxTransactionsArg(CURRENT_TAX_YEAR),
    { skip: !isTaxTransactionReview, refetchOnFocus: false },
  );
  const needsReviewCount = isTaxTransactionReview
    ? (transactionsQuery.data?.data ?? []).filter((item) => item.missing_cost_basis).length
    : 0;

  return (
    <MenuItemWrapper>
      {!isMobile && route.icon && (
        <IconButton>
          <route.icon />
        </IconButton>
      )}

      <TextContentWrapper>
        <MenuText isActive={isActive} expanded={expanded}>
          {route.title}
        </MenuText>

        {route.new && <NewLabel>new</NewLabel>}
        {needsReviewCount > 0 && <CountBadge>{needsReviewCount}</CountBadge>}
      </TextContentWrapper>
    </MenuItemWrapper>
  );
};

export default MenuItemContent;
